var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTongdao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4778"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631317",
    x: 1.69678,
    y: 1.375,
    width: 5.7943,
    height: 13.25,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 43",
    x1: 4.625,
    y1: 5.03125,
    x2: 4.625,
    y2: 10.9688,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631318",
    d: "M3.00769 9.28735L4.59375 10.8734L6.17981 9.28735",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4779"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631317_2",
    x: 15.335,
    y: 14.625,
    width: 5.7943,
    height: 13.25,
    transform: "rotate(-180 15.335 14.625)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 43_2",
    x1: 12.4067,
    y1: 10.9687,
    x2: 12.4067,
    y2: 5.03125,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631318_2",
    d: "M14.024 6.71265L12.438 5.12659L10.8519 6.71265",
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongdao);
export default __webpack_public_path__ + "static/media/tongdao.b199de40b5dcab6e47ed5c407651f10f.svg";
export { ForwardRef as ReactComponent };